// 导入 抽取的 请求对象
import ajaxRequest from '../utils/request';

const reFix = 'newsadmin/InfoSetting';

// 抽取的接口方法

// 获取隐私协议列表
export function privacyList(params) {
  return ajaxRequest({
    url: reFix + '/get_list',
    method: 'GET',
    params,
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

export function privacyGetContent(id) {
  return ajaxRequest({
    url: 'news/InfoSetting' + '/get_info_setting_by_id?id=' + id,
    method: 'GET',
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 添加
export function privacyAdd(data) {
  return ajaxRequest({
    url: reFix + '/add',
    method: 'POST',
    data,
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 删除
export function privacyRemove(id) {
  return ajaxRequest({
    url: reFix + '/delete/' + id,
    method: 'DELETE',
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}
// 更新
export function privacyEdit(id, data) {
  return ajaxRequest({
    url: reFix + '/update/' + id,
    method: 'PUT',
    data,
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 上传图片
export function privacyUpload(data) {
  return ajaxRequest({
    url: 'upload/Images/upload',
    method: 'POST',
    data,
  });
}
